import { useTranslation } from "react-i18next";
import collaborateur_background from "../../assets/png/collaborateur_background.png";
import RechercheBarStart from "../RechercheBarStart/RechercheBarStart";
import styles from "./InscriptionBackground.module.scss";

export default function InscriptionBackground() {
  const { t } = useTranslation();

  return (
    <article className={styles.inscriptionBackground}>
      <section
        className={styles.inscriptionBackground__picture}
        style={{ backgroundImage: `url(${collaborateur_background})` }}
      >
        <section className={styles.titles_container}>
          <h1>{t("inscriptionBackground.title")}</h1>
          <h2>{t("inscriptionBackground.subtitle")}</h2>
        </section>

        <RechercheBarStart />
      </section>
    </article>
  );
}
